// extracted by mini-css-extract-plugin
module.exports = {"content":"title5SideBySide_content__wN3xA","titles":"title5SideBySide_titles__wyHC0","bodies":"title5SideBySide_bodies__fzp82","buttonGroup":"title5SideBySide_buttonGroup__zA6Qf"};